import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { SITE } from "../constants/site";

export default function CallFloat() {
  return (
    <motion.a
      href={`tel:${SITE.phoneRaw}`}
      data-testid="call-float-button"
      aria-label="Call now"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 2.4, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-20 left-6 z-50 h-14 w-14 rounded-full bg-primary border border-white/30 flex items-center justify-center hover:bg-[#154d8f] hover:scale-105 transition-[background-color,transform] shadow-[0_8px_30px_rgba(18,32,49,0.25)]"
    >
      <span className="absolute inset-0 rounded-full bg-primary animate-pulse-ring" />
      <Phone size={22} className="relative text-white" strokeWidth={1.5} />
    </motion.a>
  );
}
